"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _spauiUtils = require("@tencent/spaui-utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var propsSortable = props.sortable,
      isSort = props.isSort,
      propsFilterable = props.filterable,
      isFilter = props.isFilter,
      propsFixedable = props.fixedable,
      isFixed = props.isFixed;
  var sortable = false;
  var filterable = false;
  var fixedable = false;

  if (!(0, _spauiUtils.isUndefined)(isSort)) {
    sortable = isSort;
  } else {
    sortable = propsSortable;
  }

  if (!(0, _spauiUtils.isUndefined)(isFilter)) {
    filterable = isFilter;
  } else {
    filterable = propsFilterable;
  }

  if (!(0, _spauiUtils.isUndefined)(isFixed)) {
    fixedable = isFixed;
  } else {
    fixedable = propsFixedable;
  }

  return _objectSpread({}, props, {
    sortable: sortable,
    filterable: filterable,
    fixedable: fixedable
  });
};

exports["default"] = _default;